import loadSmimeComposeInfobars from './loadSmimeComposeInfobars';
import loadAttachmentPolicyInfoBars from '../orchestrators/loadAttachmentPolicyInfoBars';
import { ComposeViewState } from 'owa-mail-compose-store';
import addCLPLabelInfoBar from '../utils/addCLPLabelInfoBar';
import addEncryptionInfobarFromIRMData from '../utils/addEncryptionInfobarFromIRMData';
import addMessageClassificationInfoBar from 'owa-mail-message-classification/lib/utils/addMessageClassificationInfoBar';
import updateSensitivityInfoBar from '../utils/updateSensitivityInfoBar';
import { isFeatureEnabled } from 'owa-feature-flags';
import isCLPEnabled from 'owa-mail-clp/lib/utils/isCLPEnabled';
import { pendingLoadLabelPromise } from 'owa-mail-clp/lib/orchestrators/loadCLPUserLabelsOrchestrator';
import { action } from 'satcheljs/lib/legacy';

export default action('loadComposeInfoBars')(function loadComposeInfoBars(
    viewState: ComposeViewState
) {
    loadAttachmentPolicyInfoBars(viewState);
    updateSensitivityInfoBar(viewState);

    if (
        isFeatureEnabled('cmp-message-classification') &&
        viewState.classificationViewState &&
        viewState.classificationViewState.messageClassification
    ) {
        addMessageClassificationInfoBar(viewState);
    }

    isFeatureEnabled('cmp-smimeAdminSettings') && loadSmimeComposeInfobars(viewState);

    // Scenarios:
    // New Compose, CLP enabled ---> should show default label.
    // Reply/forward, CLP enabled, reference item has RMS and has label ---> should only show label.
    // Reply/forward, CLP enabled, reference item has RMS and does not have label ---> should show RMS template and default label.
    // Reply/forward, CLP enabled, reference item does not have RMS and have label ---> only label should show.
    // Reply/forward, CLP not enabled, reference item has RMS and does have label ---> should only show RMS template.
    // Reply/forward, CLP not enabled, reference item does not have RMS and does/does not have label ---> should not show any infobar.

    if (!isCLPEnabled()) {
        addEncryptionInfobarFromIRMData(viewState);
    }

    if (pendingLoadLabelPromise) {
        pendingLoadLabelPromise.then(() => {
            addCLPLabelInfoBar(viewState);
        });
    } else {
        addCLPLabelInfoBar(viewState);
    }
});
